import { Badge, Flex } from 'antd';
import { useMemo } from 'react';

import {
  usePendingOpenReportMessages,
  usePendingOpenTickets,
  useTeacherPendingMessages
} from '@/store';

export const PendingSupportsBadge = () => {
  const { pendingTickets, isLoading: isLoadingTickets } = usePendingOpenTickets();
  const { pendingMessages, isLoading: isLoadingTutoringGroups } = useTeacherPendingMessages();
  const { pendingReports, isLoading: isLoadingProblemReports } = usePendingOpenReportMessages();

  const totalPendingMessages = useMemo(() => {
    return pendingTickets + (pendingMessages ?? 0) + pendingReports;
  }, [pendingTickets, pendingMessages, pendingReports]);

  if (isLoadingTickets || isLoadingTutoringGroups || isLoadingProblemReports) return null;

  return (
    <Flex align="center" justify="center">
      <Badge count={totalPendingMessages} />
    </Flex>
  );
};
